var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCautionfailedicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19738_64308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9992 56.9999C16.9992 79.0918 34.9082 97.0008 57.0001 97.0008C79.092 97.0008 97.001 79.0918 97.001 56.9999C97.001 34.908 79.092 16.999 57.0001 16.999C34.9082 16.999 16.9992 34.908 16.9992 56.9999ZM56.9988 32.0062C54.2373 32.0062 51.9988 34.2448 51.9988 37.0062L51.9988 57.0067C51.9988 59.7681 54.2373 62.0067 56.9988 62.0067C59.7602 62.0067 61.9988 59.7681 61.9988 57.0067L61.9988 37.0062C61.9988 34.2448 59.7602 32.0062 56.9988 32.0062ZM51.4988 77.0083C51.4987 73.9708 53.9612 71.5083 56.9987 71.5083C60.0363 71.5083 62.4987 73.9708 62.4988 77.0083L62.4988 77.675C62.4988 80.7126 60.0363 83.175 56.9988 83.175C53.9612 83.175 51.4988 80.7126 51.4988 77.675L51.4988 77.0083Z",
    fill: "#DF4B2D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 97,
    height: 97,
    rx: 48.5,
    stroke: "#DF4B2D",
    strokeOpacity: 0.28,
    strokeWidth: 17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19738_64308"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionfailedicon);
export default __webpack_public_path__ + "static/media/cautionfailedicon.1080c1b6d0d7ca2adc363d6ba44764b5.svg";
export { ForwardRef as ReactComponent };